import axios from "../axios";

export default {
    authenticate (data) {
        localStorage.setItem('accessToken', data.token)
    },

    logout () {
        delete localStorage.user
        delete localStorage.userInfo
        delete localStorage.accessToken
    },

    loggedIn () {
        return !!localStorage.user
    },
}
